const colorOptions = document.querySelectorAll('button.color-attribute:not(.hydrotherapy-attribute)');
const finishOptions = document.querySelectorAll('button.finish-attribute');
const jetTrimFinishOptions = document.querySelectorAll('button.jet-trim-finish-attribute');
const drainFinishOptions = document.querySelectorAll('button.drain-finish-attribute');
const hydrotherapyOptions = document.querySelectorAll('button.hydrotherapy-attribute');  
const packageOptions = document.querySelectorAll('.package-checkbox');
const equipmentLocationSelect = document.querySelector('#equipment-location-select');
const whisperTechnologySelect = document.querySelector('#whisper-technology');
const whisperPlusTechnologySelect = document.querySelector('#whisper-plus-technology');
const controlsSelect = document.querySelector('#controls');
const accessPanelsSelect = document.querySelector('#access-panels');
const sizeSelect = document.querySelector('#size');

const tubFillerSelect = document.querySelector('#tub-filler');
const finishSelect = document.querySelector('#finish');
const jetTrimFinish = document.querySelector('#jet-trim-finish');
const drainFinish = document.querySelector('#drain-finish');

const colorDisplayAttribute = document.querySelector('.attribute .color.title .display-attribute-value');
const finishDisplayAttribute = document.querySelector('.attribute .finish.title .display-attribute-value');
const jetTrimFinishDisplayAttribute = document.querySelector('.attribute .jet-trim-finish.title .display-attribute-value');
const drainFinishDisplayAttribute = document.querySelector('.attribute .drain-finish.title .display-attribute-value');

const hydrotherapyDisplayAttribute = document.querySelector('.attribute .hydrotherapy .display-attribute-value');
const packageDisplayAttribute = document.querySelector('.attribute .packages .display-attribute-value');

const equipmentLocationDisplayAttribute = document.querySelector('.attribute .equipment-location-label .display-attribute-value');
const whisperTechnologyDisplayAttribute = document.querySelector('.attribute .whisper-technology-label .display-attribute-value');
const whisperPlusTechnologyDisplayAttribute = document.querySelector('.attribute .whisper-plus-technology-label .display-attribute-value');
const controlsDisplayAttribute = document.querySelector('.attribute .controls-label .display-attribute-value');
const accessPanelsDisplayAttribute = document.querySelector('.attribute .access-panels-label .display-attribute-value');
const sizeDisplayAttribute = document.querySelector('.attribute .size-label .display-attribute-value');

const tubFillerDisplayAttribute = document.querySelector('.attribute .tub-filler-label .display-attribute-value');

const changeSelectionLinks = document.querySelectorAll('.change-selection');
const resetSelectionLink = document.querySelector('.reset-attributes');

const productImageSlides = document.querySelectorAll('.product-image-slider__body .slick-slide');
const thumbnailSlides = document.querySelectorAll('.product-image-slider__thumbnails .slick-slide');

const startingPriceLabel = document.querySelector('.product-template__body--price .price-label .starting-price');
// console.log(productImageSlides,thumbnailSlides);

if (startingPriceLabel) {
  updateStartingPrice();
}

productImageSlides.forEach(slide => {
  const fileName = slide.getAttribute('data-file-name');
  if (fileName.includes('FilterImage')) {
    slide.classList.add('filter-image');
  }
});

thumbnailSlides.forEach(slide => {
  const fileName = slide.getAttribute('data-file-name');
  if (fileName.includes('FilterImage')) {
    slide.classList.add('filter-image');
  }
});

changeSelectionLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    const optionName = e.target.dataset.option;
    // window.filteredChildProducts = [...window.childProducts];
    resetOption(optionName);
    filterProducts(optionName, false);
    updateProductImage();
  });
});

document.addEventListener('DOMContentLoaded', () => {  
  colorOptions.forEach(option => {
    option.addEventListener('click', (e) => {
      e.preventDefault();
      const colorName = e.target.getAttribute('data-value');
      toggleColorOption(option, colorName);
      filterProducts('Color');
      updateProductImage();
    });
  });
  
  finishOptions.forEach(option => {
    option.addEventListener('click', (e) => {
      e.preventDefault();
      const finishName = e.target.getAttribute('data-value');
      toggleFinishOption(option, finishName);
      filterProducts('Finish');
      updateProductImage();
    });
  });

  drainFinishOptions.forEach(option => {
    option.addEventListener('click', (e) => {
      e.preventDefault();
      const drainFinishName = e.target.getAttribute('data-value');
      toggleDrainFinishOption(option, drainFinishName);
      filterProducts('Drain Finish');
      updateProductImage();
    });
  });

  jetTrimFinishOptions.forEach(option => {
    option.addEventListener('click', (e) => {
      e.preventDefault();
      const jetTrimFinishName = e.target.getAttribute('data-value');
      toggleJetTrimFinishOption(option, jetTrimFinishName);
      filterProducts('Jet Trim Finish');
      updateProductImage();
    });
  });
    
  hydrotherapyOptions.forEach(option => {
    option.addEventListener('click', (e) => {      
      e.preventDefault();
      const hydrotherapyName = ((e.target.classList.contains('attribute-display-name')) ? e.target.innerHTML : e.target.getAttribute('data-value'));
      toggleHydrotherapyOption(option, hydrotherapyName);
      filterProducts('Hydrotherapy Experience');
      updateProductImage();
    });
  });
  
  packageOptions.forEach(option => {
    option.addEventListener('change', (e) => {
      e.preventDefault();
      const packageName = e.target.getAttribute('data-value');
      togglePackageOption(option, packageName);
      filterProducts('Packages');
      updateProductImage();
    });
  });

  if (equipmentLocationSelect) {
    equipmentLocationSelect.addEventListener('change', (e) => {
      e.preventDefault();
      const equipmentLocationName = e.target.value;
      equipmentLocationDisplayAttribute.textContent = equipmentLocationName;
      filterProducts('Equipment Location');
      e.target.disabled = (equipmentLocationName) ? true : false;
      updateProductImage();
    });
  }

  if (controlsSelect) {
    controlsSelect.addEventListener('change', (e) => {
      e.preventDefault();
      const controlPanelName = e.target.value;
      controlsDisplayAttribute.textContent = controlPanelName;
      filterProducts('Controls');
      e.target.disabled = (controlPanelName) ? true : false;
      updateProductImage();
    });
  }
  
  if (whisperTechnologySelect) {
    whisperTechnologySelect.addEventListener('change', (e) => {
      e.preventDefault();
      const whisperTechnologyName = e.target.value;
      whisperTechnologyDisplayAttribute.textContent = whisperTechnologyName;
      filterProducts('Whisper Technology');
      e.target.disabled = (whisperTechnologyName) ? true : false;
      updateProductImage();
    });
  }
  
  if (whisperPlusTechnologySelect) {
    whisperPlusTechnologySelect.addEventListener('change', (e) => {
      e.preventDefault();
      const whisperPlusTechnologyName = e.target.value;
      whisperPlusTechnologyDisplayAttribute.textContent = whisperPlusTechnologyName;
      filterProducts('Whisper+ Technology');
      e.target.disabled = (whisperPlusTechnologyName) ? true : false;
      updateProductImage();
    });
  }

  if (tubFillerSelect) {
    tubFillerSelect.addEventListener('change', (e) => {
      e.preventDefault();
      const tubFillerName = e.target.value;
      tubFillerDisplayAttribute.textContent = tubFillerName;
      filterProducts('Tub Filler');
      e.target.disabled = (tubFillerName) ? true : false;
      updateProductImage();
    });
  }
  
  if (accessPanelsSelect) {
    accessPanelsSelect.addEventListener('change', (e) => {
      e.preventDefault();
      const accessPanelsName = e.target.value;
      accessPanelsDisplayAttribute.textContent = accessPanelsName;
      filterProducts('Access Panels');
      e.target.disabled = (accessPanelsName) ? true : false;
      updateProductImage();
    });
  }

  if (sizeSelect) {
    sizeSelect.addEventListener('change', (e) => {
      e.preventDefault();
      const sizeName = e.target.value;
      sizeDisplayAttribute.textContent = sizeName;
      filterProducts('Size');
      e.target.disabled = (sizeName) ? true : false;
      updateProductImage();
    });
  }
  
  if (resetSelectionLink) {
    resetSelectionLink.addEventListener('click', () => {
      resetSelections();
      resetSelectionStep();
      const $mainSlider = $('.product-image-slider__body');
      const $thumbSlider = $('.product-image-slider__thumbnails');
      $mainSlider.slick('slickGoTo', 0, true);
      $thumbSlider.slick('slickGoTo', 0, true);
    });
  }

  advanceSelectionStep();
  // forceRemainingSelection();  
});

function resetSelectionStep() {
  const productOptions = document.querySelectorAll('.product-option-column');
  let i = 0;
  productOptions.forEach(option => {
    if (i === 0) {
      option.classList.add('current-step');
    }
    else {
      option.classList.remove('current-step');
    }
    i++;
  });
}

function advanceSelectionStep() {
  //remove current-step from the last .selected column
  const lastProductOption = document.querySelector('.product-option-column.selected.current-step');
  if (lastProductOption) {
    lastProductOption.classList.remove('current-step');
  }
  const unselectedProductOption = document.querySelector('.product-option-column:not(.selected)');
  if (unselectedProductOption) {
    unselectedProductOption.classList.add('current-step');
    unselectedProductOption.focus();
    
    // Scroll to the element with smooth behavior and a small offset from the top
    unselectedProductOption.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });
  }
  else {
    const atcBtn = document.querySelector('.add-to-cart');
    atcBtn.focus();
    atcBtn.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });
  }
}

function resetOption(optionName) {
  switch(optionName) {
    case 'Color':
      if (colorOptions.length > 0) {
        colorOptions.forEach(option => {
          if (option.classList.contains('selected')) {
            option.classList.remove('selected');
          }
        });        
        colorDisplayAttribute.textContent = '';
      }
      break;
    case 'Finish':
      if (finishOptions.length > 0) {
        finishOptions.forEach(option => {
          if (option.classList.contains('selected')) {
            option.classList.remove('selected');
          }
        });
        finishDisplayAttribute.textContent = '';
      }
      break;
    case 'Drain Finish':
      if (drainFinishOptions.length > 0) {
        drainFinishOptions.forEach(option => {
          if (option.classList.contains('selected')) {
            option.classList.remove('selected');
          }
        });
        drainFinishDisplayAttribute.textContent = '';
      }
      break;
    case 'Jet Trim Finish':
      if (jetTrimFinishOptions.length > 0) {
        jetTrimFinishOptions.forEach(option => {
          if (option.classList.contains('selected')) {
            option.classList.remove('selected');
          }
        });
        jetTrimFinishDisplayAttribute.textContent = '';
      }
      break;
    case 'Hydrotherapy Experience':
      if (hydrotherapyOptions.length > 0) {
        hydrotherapyOptions.forEach(option => {
          if (option.classList.contains('selected')) {
            option.classList.remove('selected');
          }
        });
        hydrotherapyDisplayAttribute.textContent = '';
      }
      break;
    case 'Packages':
      if (packageOptions.length > 0) {
        packageOptions.forEach(option => {
          if (option.classList.contains('selected')) {
            option.classList.remove('selected');          
            option.parentElement.classList.remove('selected');
            option.checked = false;
          }
        });
        packageDisplayAttribute.textContent = '';
      }
      break;
    case 'Controls':
      if (controlsSelect) {
        controlsSelect.value = "";
        controlsDisplayAttribute.textContent = '';
        controlsSelect.disabled = false;
      }
      break; 
    case 'Equipment Location':
      if (equipmentLocationSelect) {
        equipmentLocationSelect.value = "";
        equipmentLocationDisplayAttribute.textContent = '';
        equipmentLocationSelect.disabled = false;
      }
      break;        
    case 'Whisper Technology':
      if (whisperTechnologySelect) {
        whisperTechnologySelect.value = "";
        whisperTechnologyDisplayAttribute.textContent = '';
        whisperTechnologySelect.disabled = false;
      }
      break;
    case 'Whisper+ Technology':
      if (whisperPlusTechnologySelect) {
        whisperPlusTechnologySelect.value = "";
        whisperPlusTechnologyDisplayAttribute.textContent = '';
        whisperPlusTechnologySelect.disabled = false;
      }
      break;
    case 'Tub Filler':
      if (tubFillerSelect) {
        tubFillerSelect.value = "";
        tubFillerDisplayAttribute.textContent = '';
        tubFillerSelect.disabled = false;
      }
      break;
    case 'Access Panels':
      if (accessPanelsSelect) {
        accessPanelsSelect.value = "";
        accessPanelsDisplayAttribute.textContent = '';
        accessPanelsSelect.disabled = false;
      }
      break;   
    case 'Size':
      if (sizeSelect) {
        sizeSelect.value = "";
        sizeDisplayAttribute.textContent = '';
        sizeSelect.disabled = false;
      }
      break;
  }        
}

function resetSelections() {
  window.filteredChildProducts = [...window.childProducts];
  resetOption('Color');
  resetOption('Hydrotherapy Experience');  
  resetOption('Equipment Location');
  resetOption('Packages');
  resetOption('Controls');
  resetOption('Whisper Technology');
  resetOption('Whisper+ Technology');
  resetOption('Tub Filler');
  resetOption('Finish');
  resetOption('Drain Finish');
  resetOption('Jet Trim Finish');
  resetOption('Access Panels');
  resetOption('Size');

  toggleAvailableOptions(true);
  updateProductImage();
}

function toggleColorOption(option, colorName) {    
  const alreadySelected = option.classList.contains('selected');
  colorOptions.forEach(option => {
    option.classList.remove('selected');
  });
  if (!alreadySelected) {
    option.classList.add('selected');
    colorDisplayAttribute.textContent = colorName;
  }
  else {
    option.classList.remove('selected');
    colorDisplayAttribute.textContent = '';
  }
}  

function toggleFinishOption(option, finishName) {    
  const alreadySelected = option.classList.contains('selected');
  finishOptions.forEach(option => {
    option.classList.remove('selected');
  });
  if (!alreadySelected) {
    option.classList.add('selected');
    finishDisplayAttribute.textContent = finishName;
  }
  else {
    option.classList.remove('selected');
    finishDisplayAttribute.textContent = '';
  }
}

function toggleDrainFinishOption(option, drainFinishName) {    
  const alreadySelected = option.classList.contains('selected');
  drainFinishOptions.forEach(option => {
    option.classList.remove('selected');
  });
  if (!alreadySelected) {
    option.classList.add('selected');
    drainFinishDisplayAttribute.textContent = drainFinishName;
  }
  else {
    option.classList.remove('selected');
    drainFinishDisplayAttribute.textContent = '';
  }
}

function toggleJetTrimFinishOption(option, jetTrimFinishName) {    
  const alreadySelected = option.classList.contains('selected');
  jetTrimFinishOptions.forEach(option => {
    option.classList.remove('selected');
  });
  if (!alreadySelected) {
    option.classList.add('selected');
    jetTrimFinishDisplayAttribute.textContent = jetTrimFinishName;
  }
  else {
    option.classList.remove('selected');
    jetTrimFinishDisplayAttribute.textContent = '';
  }
}

function toggleHydrotherapyOption(option, hydrotherapyName) {    
  const alreadySelected = option.classList.contains('selected');
  hydrotherapyOptions.forEach(option => {
    option.classList.remove('selected');
  });
  if (!alreadySelected) {
    option.classList.add('selected');    
    hydrotherapyDisplayAttribute.textContent = hydrotherapyName;
  }
  else {
    option.classList.remove('selected');
    hydrotherapyDisplayAttribute.textContent = '';
  }
}

function togglePackageOption(option, packageName) {  
  const alreadySelected = option.classList.contains('selected');
  console.log('alreadySelected', alreadySelected);
  packageOptions.forEach(packageOption => {
    packageOption.classList.remove('selected');
    if (packageOption != option) {
      packageOption.checked = false;
    }
  });
  if (!alreadySelected) {
    option.classList.add('selected');
    packageDisplayAttribute.textContent = packageName;
  }
  else {
    option.classList.remove('selected');
    packageDisplayAttribute.textContent = '';
  }
}

/* Main entry function for filtering logic */
function filterProducts(attribute, forceRemaining = true) {  
  toggleLoader(true);  
  window.filteredChildProducts = [...window.childProducts]; // Create a new array copy
  // console.log('initial window.filteredChildProducts', window.filteredChildProducts);
  
  //refine filtered products by the currently selected option
  console.log('refineFilteredProducts', attribute);
  refineFilteredProducts(attribute); 


  //refine filtered products by remaining selected options
  const remainingOptionElements = document.querySelectorAll(`.attribute-values:not([data-option="${attribute}"])`);
  remainingOptionElements.forEach(el => {
    const option = el.dataset.option;
    refineFilteredProducts(option);    
  });

  updateProductUI();
  
  //force selection when only one selectable option remains
  // if (forceRemaining) {
  //   forceRemainingSelection();
  // }
  advanceSelectionStep(); 
  showHowToModal();    
}

function showHowToModal() {
  const hasSeenModal = getCookie('customize-modal-seen');
  if (!hasSeenModal) {
    setCookie('customize-modal-seen', 'true', 365);
    const howToModal = new bootstrap.Modal(document.getElementById('How-To-Customize-Modal'));
    howToModal.show();
  }
}

/* no longer using this due to some random bugs that cropped up after implementing the stepwise selection process */
function forceRemainingSelection() {
  console.log('forceRemainingSelection');
  const optionsNotSelected = document.querySelectorAll(`.product-option-column:not(.selected)`);
  optionsNotSelected.forEach(el => {
    const attributes = el.querySelectorAll('.attribute-values');
    const attributeDisplayName = el.querySelector('.display-attribute-value');
    for (const attribute of attributes) {
      console.log('got unselected attribute', attribute);
      
      const availableOptions = attribute.querySelectorAll(':scope > *:not(.selected):not(.disabled)');
      console.log('availableOptions', availableOptions);
      if (availableOptions.length === 1) {   
        if (availableOptions[0].nodeName === 'SELECT') {
          //check if only one option without .selected or .disabled class
          const options = availableOptions[0].querySelectorAll('option:not(.selected):not(.disabled):not(.option-placeholder)');
          // console.log('options', options)
          if (options.length === 1) {
            console.log('has only one unselected attribute', options)
            const dataOption = availableOptions[0].dataset.option;
            const dataValue = options[0].value;

            options[0].classList.add('selected');
            availableOptions[0].value = dataValue;
            attributeDisplayName.textContent = dataValue;
            availableOptions[0].disabled = true;
            console.log('option and value', dataOption, dataValue);
            filterProducts(dataOption, false);
          }
        }
        else {
          console.log('has only one unselected attribute', availableOptions)
          const dataOption = availableOptions[0].dataset.option;
          const dataValue = availableOptions[0].dataset.value;

          availableOptions[0].classList.add('selected');
          attributeDisplayName.textContent = dataValue;

          console.log('option and value', dataOption, dataValue);
          filterProducts(dataOption, false);
        }
      }
      // attribute.children.some
      // for (let childNode of attribute.childNodes) {
      //   let hasOnlyOneOption = false;
      //   if (!childNode.classList.contains('selected')) {
      //     childNode.classList.remove('selected');
      //   }
      // }
    }
  });
}

function updateProductUI() {
  //reset disabled options initially
  toggleAvailableOptions(true);
  //disable any options that are no longer available according to the newly filtered products
  toggleAvailableOptions();  
}

function toggleLoader(show) {
  const loader = document.querySelector('.loader-overlay');
  if (loader) {
    loader.classList.toggle('d-none', !show);
  }
}
// Cache DOM elements and other variables for better performance
const imageCache = new Map();
let lastImageUrl = '';

function preloadImage(url) {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error('No URL provided'));
      return;
    }
    
    // Return cached promise if image is already being loaded
    if (imageCache.has(url)) {
      resolve(imageCache.get(url));
      return;
    }
    
    const img = new Image();
    const promise = new Promise((imgResolve, imgReject) => {
      img.onload = () => {
        // Only cache successful loads
        imageCache.set(url, img);
        imgResolve(img);
      };
      img.onerror = imgReject;
      // Start loading the image
      img.src = url;
    });
    
    // Store the promise in cache immediately
    imageCache.set(url, promise);
    promise.catch(() => imageCache.delete(url)); // Remove from cache on error
    
    resolve(promise);
  });
}

function generateSrcSet(baseUrl, sizes = [500, 750, 1000, 1500, 2000]) {
  try {
    // Parse the URL to handle query parameters properly
    console.log('baseUrl', baseUrl);
    const url = new URL(toAbsoluteUrl(baseUrl));
    const params = new URLSearchParams(url.search);
    
    // Get the original path without query parameters
    const pathParts = url.pathname.split('/');
    const filename = pathParts[pathParts.length - 1]; 
    
    // Extract the base filename without dimensions or extension
    const baseFilename = filename.replace(/_\d+x\d+(\.\w+)?$/, '');
    const extension = filename.match(/\.(\w+)(?:\?|$)/)?.[1] || 'jpg';
    console.log('baseFilename', baseFilename);
    console.log('extension', extension);    
    // Generate srcset with the same format as the original image
    return sizes.map(size => {
      // Clone the URL to avoid modifying the original
      const imgUrl = new URL(toAbsoluteUrl(baseUrl));
      const imgParams = new URLSearchParams(imgUrl.search);
      
      // Update size parameters if they exist
      if (imgParams.has('width') || imgParams.has('height')) {
        imgParams.set('width', size);
        imgParams.set('height', size);
        imgParams.set('crop', 'center');
      } else {
        // If no size parameters, use the Shopify size suffix pattern
        const sizedFilename = `${baseFilename}_${size}x${size}.${extension}`;
        pathParts[pathParts.length - 1] = sizedFilename;
        imgUrl.pathname = pathParts.join('/');
      }
      
      // Update the search params
      imgUrl.search = imgParams.toString();
      
      return `${imgUrl.toString()} ${size}w`;
    }).join(', ');
  } catch (e) {
    console.error('Error generating srcset:', e);
    // Fallback to the original URL if there's an error
    return `${baseUrl} 1000w`;
  }
}

// Helper to get a 3000x3000 zoom image URL from a Shopify image URL
async function getZoomImageUrl(url) {
  // If URL has width/height params, update them
  if (url.match(/[?&]width=\d+/) && url.match(/[?&]height=\d+/)) {
    url = url.replace(/([?&]width=)\d+/, '$13000').replace(/([?&]height=)\d+/, '$13000');
    return url;
  }
  // If URL has _WxH, replace it
  if (/_\d{2,4}x\d{2,4}/.test(url)) {
    return url.replace(/(_\d{2,4}x\d{2,4})/, '_3000x3000');
  }
  // Otherwise, just return original
  return url;
}

function getThumbSizeOfShopifyImageUrl(url) {
  // This regex looks for a dot followed by 3 or 4 alphanumeric characters (the file extension)
  // at the end of the filename part of the URL, before any query parameters.
  // It captures the extension in a group.
  const regex = /(\.[a-zA-Z0-9]{3,4})(\?.*|$)/;

  if (url.match(regex)) {
    return url.replace(regex, '_100x$1$2');
  } else {
    // If no clear extension is found, return the original URL
    console.warn("Could not find a file extension to modify in the URL:", url);
    return url;
  }
}

// Helper to ensure a URL is absolute for use with new URL()
function toAbsoluteUrl(url) {
  if (url.startsWith('//')) {
    return window.location.protocol + url;
  }
  if (url.startsWith('/')) {
    return window.location.origin + url;
  }
  return url;
}

async function updateProductImage() {
  // Use requestAnimationFrame to ensure smooth UI updates
  requestAnimationFrame(async () => {
    const noOptionsSelected = document.querySelectorAll('.product-option-column.selected').length === 0;
    const noFiltersApplied = window.childProducts && 
                           window.childProducts.length === window.filteredChildProducts.length &&
                           noOptionsSelected;
    
    // Cache slider elements
    const $mainSlider = $('.product-image-slider__body');
    const $thumbSlider = $('.product-image-slider__thumbnails');
    const isSlickAvailable = typeof $.fn.slick === 'function';
    
    // If no filters are applied, show the first slide (main product image)
    if (noFiltersApplied && isSlickAvailable) {
      if ($mainSlider.hasClass('slick-initialized')) {
        $mainSlider.slick('slickGoTo', 0, true);
      }
      if ($thumbSlider.hasClass('slick-initialized')) {
        $thumbSlider.slick('slickGoTo', 0, true);
      }
      toggleLoader(false);
      return;
    }

    const firstAvailableProduct = window.filteredChildProducts?.[0];
    if (!firstAvailableProduct?.featured_image) {
      toggleLoader(false);
      return;
    }
    console.log('firstAvailableProduct',firstAvailableProduct)

    const newImageUrl = firstAvailableProduct.featured_image;
    
    // Skip if we're already showing this image
    if (newImageUrl === lastImageUrl) {
      toggleLoader(false);
      const filterSlide = $mainSlider.find('.slick-slide.filter-image').data('slick-index');            
      $mainSlider.slick('slickGoTo', filterSlide, true);            
      $thumbSlider.slick('slickGoTo', filterSlide, true);      
      return;
    }
    
    lastImageUrl = newImageUrl;
    
    try {
      // Preload the new image
      await preloadImage(newImageUrl);
      
      // Update main slider
      const mainImageSlide = document.querySelector('.product-image-slider__body .slick-slide.filter-image');
      const mainImg = mainImageSlide?.querySelector('img.mainImg');
      const zoomImg = mainImageSlide?.querySelector('img.zoomImg');
      if (zoomImg) {
        zoomImg.src = await getZoomImageUrl(newImageUrl);
      }
      if (mainImg) {
        // Generate srcset first
        const srcset = generateSrcSet(newImageUrl);
        
        // Update image attributes in one go
        requestAnimationFrame(() => {
          // Show loader before loading new image
          toggleLoader(true);
          mainImg.onload = function() {
            toggleLoader(false);
            mainImg.onload = null;
          };
          mainImg.onerror = function() {
            toggleLoader(false);
            mainImg.onerror = null;
          };
          mainImg.src = newImageUrl;
          mainImg.setAttribute('data-src', newImageUrl);
          mainImg.setAttribute('data-srcset', srcset);
          mainImg.setAttribute('srcset', srcset);
          
          // Force browser to repaint
          mainImg.style.opacity = '0.99';
          setTimeout(() => { mainImg.style.opacity = '1'; }, 0);
          
          // Refresh slider position
          if (isSlickAvailable && $mainSlider.hasClass('slick-initialized')) {
            const currentSlide = $mainSlider.find('.slick-slide.filter-image').data('slick-index');
            $mainSlider.slick('slickGoTo', currentSlide, true);
          }
        });
      }
      
      // Update thumbnail slider
      const thumbnailSlide = document.querySelector('.product-image-slider__thumbnails .slick-slide.filter-image');
      const thumbImg = thumbnailSlide?.querySelector('img');
      
      if (thumbImg) {
        requestAnimationFrame(() => {
          const thumbImgUrl = getThumbSizeOfShopifyImageUrl(newImageUrl);
          thumbImg.src = thumbImgUrl;
          thumbImg.setAttribute('data-src', thumbImgUrl);
          
          if (isSlickAvailable && $thumbSlider.hasClass('slick-initialized')) {
            const currentThumb = $thumbSlider.find('.slick-slide.filter-image').data('slick-index');
            $thumbSlider.slick('slickGoTo', currentThumb, true);
          }
        });
      }
      
    } catch (error) {
      console.error('Error updating product image:', error);
    } finally {
      toggleLoader(false);
    }
  });
}
function toggleAvailableOptions(reset = false, resetOnlyOption = null) { 
  const productOptElements = document.querySelectorAll(`.attribute-values`);
  let optionsSelectedText = "";
  let hasAvailableOption = false;
  productOptElements.forEach(el => {
    const productOption = el.dataset.option; 
    if (resetOnlyOption && resetOnlyOption !== productOption) {
      return;
    }
    switch(productOption) {
      case 'Color':
        if (!Array.from(colorOptions).some(option => option.classList.contains('selected'))) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }
        colorOptions.forEach(option => {
          const optionValue = option.dataset.value;
          const isAvailable = window.filteredChildProducts.some(product => product.color === optionValue);
          option.classList.toggle('disabled', !isAvailable && !reset); 
          (!isAvailable && !reset) ? option.setAttribute('disabled', true) : option.removeAttribute('disabled');
        });
        break;
      case 'Finish':
        hasAvailableOption = false;

        finishOptions.forEach(option => {
          const optionValue = option.dataset.value;
          const isAvailable = window.filteredChildProducts.some(product => product.finish === optionValue);
          if (isAvailable) {
            hasAvailableOption = true;
          }
          option.classList.toggle('disabled', !isAvailable && !reset); 
          (!isAvailable && !reset) ? option.setAttribute('disabled', true) : option.removeAttribute('disabled');
        });

        disableOptionStep(productOption, hasAvailableOption);
        if (!Array.from(finishOptions).some(option => option.classList.contains('selected')) && hasAvailableOption) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }

        break;
      case 'Drain Finish':
        hasAvailableOption = false;

        drainFinishOptions.forEach(option => {
          const optionValue = option.dataset.value;
          const isAvailable = window.filteredChildProducts.some(product => product.drain_finish === optionValue);
          if (isAvailable) {
            hasAvailableOption = true;
          }
          option.classList.toggle('disabled', !isAvailable && !reset); 
          (!isAvailable && !reset) ? option.setAttribute('disabled', true) : option.removeAttribute('disabled');
        });
  
        disableOptionStep(productOption, hasAvailableOption);
        if (!Array.from(drainFinishOptions).some(option => option.classList.contains('selected')) && hasAvailableOption) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }

        break;
      case 'Jet Trim Finish':
        hasAvailableOption = false;

        jetTrimFinishOptions.forEach(option => {
          const optionValue = option.dataset.value;
          const isAvailable = window.filteredChildProducts.some(product => product.jet_trim_finish === optionValue);
          if (isAvailable) {
            hasAvailableOption = true;
          }
          option.classList.toggle('disabled', !isAvailable && !reset); 
          (!isAvailable && !reset) ? option.setAttribute('disabled', true) : option.removeAttribute('disabled');
        });

        disableOptionStep(productOption, hasAvailableOption);
        if (!Array.from(jetTrimFinishOptions).some(option => option.classList.contains('selected')) && hasAvailableOption) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }

        break;
      case 'Hydrotherapy Experience':
        if (!Array.from(hydrotherapyOptions).some(option => option.classList.contains('selected'))) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }
        hydrotherapyOptions.forEach(option => {
          const optionValue = option.dataset.value;
          const isAvailable = window.filteredChildProducts.some(product => product.experience === optionValue);
          option.classList.toggle('disabled', !isAvailable && !reset);
          (!isAvailable && !reset) ? option.setAttribute('disabled', true) : option.removeAttribute('disabled');
        });
        break;
      case 'Packages':        
        hasAvailableOption = false;
        packageOptions.forEach(option => {          
          const optionValue = option.dataset.value;
          // console.log(optionValue);
          let isAvailable = true;
          if (optionValue === 'Chromatherapy') {
            isAvailable = window.filteredChildProducts.some(product => product.chromatherapy === 'Yes');
          }
          else if (optionValue === 'Illumatherapy') {
            isAvailable = window.filteredChildProducts.some(product => product.illumatherapy === 'Yes');
          }
          else if (optionValue === 'Heater') {
            isAvailable = window.filteredChildProducts.some(product => product.heater_included === 'Yes' && (product.chromatherapy === 'No' || !product.chromatherapy));
          }
          else if (optionValue === 'No Heater') {
            isAvailable = window.filteredChildProducts.some(product => product.heater_included === 'No');
          }
          else if (optionValue === 'Heater and Chromatherapy') {
            isAvailable = window.filteredChildProducts.some(product => product.heater_included === 'Yes' && product.chromatherapy === 'Yes');
          }
          else if (optionValue === 'Heater and Illumatherapy') {
            isAvailable = window.filteredChildProducts.some(product => product.heater_included === 'Yes' && product.illumatherapy === 'Yes');
          }
          const packageAttribute = option.closest('.package-attribute');
          if (isAvailable) {
            hasAvailableOption = true;
          }
          if (isAvailable || reset) {
            option.removeAttribute('disabled')
            packageAttribute.classList.remove('disabled');
          }
          else {
            option.setAttribute('disabled', true)
            packageAttribute.classList.add('disabled');
          }
          option.classList.toggle('disabled', !isAvailable && !reset);
        });
        disableOptionStep(productOption, hasAvailableOption);
        if (!Array.from(packageOptions).some(option => option.classList.contains('selected')) && hasAvailableOption) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }

        break;
      case 'Equipment Location':
        const pumpLocationOptions = equipmentLocationSelect.options;
        
        // console.log('pumplocationoptions', pumpLocationOptions)
        hasAvailableOption = false;
        for (let option of pumpLocationOptions) {          
          const optionValue = option.value;
          const isAvailable = (!option.value) ? true : window.filteredChildProducts.some(product => product.equipment_location === optionValue);
          if (option.value && isAvailable) {
            hasAvailableOption = true;
          }
          if (isAvailable || reset) {
            option.removeAttribute('disabled')
          }
          else {
            option.setAttribute('disabled', true)
          }
          option.classList.toggle('disabled', !isAvailable && !reset);
        }  
        disableOptionStep(productOption, hasAvailableOption);

        if (!equipmentLocationSelect.value && hasAvailableOption) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }
        
        break;        
      case 'Whisper Technology':
        const whisperTechnologyOptions = whisperTechnologySelect.options;
        
        hasAvailableOption = false;
        for (let option of whisperTechnologyOptions) {
          const optionValue = option.value;
          const isAvailable = (!option.value) ? true : window.filteredChildProducts.some(product => product.whisper === optionValue);
          if (option.value && isAvailable) {
            hasAvailableOption = true;
          }
          if (isAvailable || reset) {
            option.removeAttribute('disabled')
          }
          else {
            option.setAttribute('disabled', true)
          }
          option.classList.toggle('disabled', !isAvailable && !reset);
        }        

        if (!whisperTechnologySelect.value && hasAvailableOption) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }
        disableOptionStep(productOption, hasAvailableOption);

        break;
      case 'Whisper+ Technology':
        const whisperPlusTechnologyOptions = whisperPlusTechnologySelect.options;
        
        hasAvailableOption = false;
        for (let option of whisperPlusTechnologyOptions) {
          const optionValue = option.value;
          const isAvailable = (!option.value) ? true : window.filteredChildProducts.some(product => product.whisper_plus === optionValue);
          if (option.value && isAvailable) {
            hasAvailableOption = true;
          }
          if (isAvailable || reset) {
            option.removeAttribute('disabled')
          }
          else {
            option.setAttribute('disabled', true)
          }
          option.classList.toggle('disabled', !isAvailable && !reset);
        }        

        if (!whisperPlusTechnologySelect.value && hasAvailableOption) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }
        disableOptionStep(productOption, hasAvailableOption);

        break;
      case 'Tub Filler':
        const tubFillerOptions = tubFillerSelect.options;
        
        hasAvailableOption = false;
        for (let option of tubFillerOptions) {
          const optionValue = option.value;
          const isAvailable = (!option.value) ? true : window.filteredChildProducts.some(product => product.bathtub_tubfiller_bundle === optionValue);
          if (option.value && isAvailable) {
            hasAvailableOption = true;
          }
          if (isAvailable || reset) {
            option.removeAttribute('disabled')
          }
          else {
            option.setAttribute('disabled', true)
          }
          option.classList.toggle('disabled', !isAvailable && !reset);
        }        

        if (!tubFillerSelect.value && hasAvailableOption) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }
        disableOptionStep(productOption, hasAvailableOption);

        break;
      case 'Controls':
        const controlsOptions = controlsSelect.options;
        if (!controlsSelect.value) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }
        for (let option of controlsOptions) {
          const optionValue = option.value;
          const isAvailable = (!option.value) ? true : window.filteredChildProducts.some(product => product.controls === optionValue);
          if (isAvailable || reset) {
            option.removeAttribute('disabled')
          }
          else {
            option.setAttribute('disabled', true)
          }
          option.classList.toggle('disabled', !isAvailable && !reset);
        }        
        break;
      case 'Access Panels':
        const accessPanelsOptions = accessPanelsSelect.options;
        hasAvailableOption = false;        
        for (let option of accessPanelsOptions) {
          const optionValue = option.value;
          const isAvailable = (!option.value) ? true : window.filteredChildProducts.some(product => product.access_panels === optionValue);
          if (option.value && isAvailable) {
            hasAvailableOption = true;
          }          
          if (isAvailable || reset) {
            option.removeAttribute('disabled')
          }
          else {
            option.setAttribute('disabled', true)
          }
          option.classList.toggle('disabled', !isAvailable && !reset);
        }
        if (!accessPanelsSelect.value && hasAvailableOption) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }
        disableOptionStep(productOption, hasAvailableOption);
        break;
      case 'Size':
        const sizeOptions = sizeSelect.options;
        if (!sizeSelect.value) {
          optionsSelectedText += `${productOption} / `;
          toggleOptionSelectedClasses(productOption, true)
        }
        else {
          toggleOptionSelectedClasses(productOption, false)
        }
        for (let option of sizeOptions) {
          const optionValue = option.value;
          const isAvailable = (!option.value) ? true : window.filteredChildProducts.some(product => product.size === optionValue);
          if (isAvailable || reset) {
            option.removeAttribute('disabled')
          }
          else {
            option.setAttribute('disabled', true)
          }
          option.classList.toggle('disabled', !isAvailable && !reset);
        }
        break;
    }               
  });
  if (optionsSelectedText) {
    // console.log('optionsSelectedText',optionsSelectedText);
    optionsSelectedText = optionsSelectedText.slice(0, -3);
    document.querySelector('.availability-msg').classList.remove('d-none');
    document.querySelector('.availability-msg .availability-msg--text').textContent = `Select ${optionsSelectedText}`;    
  }
  else {
    document.querySelector('.availability-msg').classList.add('d-none');
  }
  toggleAtcButtonAndPricing();
}
function toggleAtcButtonAndPricing() {
  const startingPriceLabel = document.querySelector('.product-template__body--price .price-label');
  const atcButton = document.querySelector('button.add-to-cart');
  const regularPrice = document.querySelector('.body--price__wrapper .regular-price')
  const reuglarPriceText = regularPrice.querySelector('.regular-price--text');
  const costcoPrice = document.querySelector('.body--price__wrapper .costco-price');
  const costcoPriceLabel = costcoPrice.querySelector('.costco-price--label');
  const costcoPricePromoLabel = costcoPrice.querySelector('.costco-price--promo-label');
  const costcoPriceText = costcoPrice.querySelector('.costco-price--text');  
  const filteredProduct = (window.filteredChildProducts.length === 1) ? window.filteredChildProducts[0] : null;
  const unselectedOptionColumns = document.querySelectorAll('.product-option-column:not(.selected)');    

  updateStartingPrice();

  if (!filteredProduct || unselectedOptionColumns.length > 0) {
    //disable ATC button and hide costco pricing
    startingPriceLabel.classList.remove('d-none');
    atcButton.setAttribute('disabled', true);
    regularPrice.classList.add('d-none');
    costcoPrice.classList.add('d-none');
    costcoPriceLabel.classList.add('d-none');
    costcoPricePromoLabel.classList.add('d-none');
    atcButton.textContent = 'ADD TO CART';
    return;
  }

  startingPriceLabel.classList.toggle('d-none', filteredProduct);

  //enable ATC button if available
  if (filteredProduct.available) {
    atcButton.removeAttribute('disabled');
    atcButton.textContent = 'ADD TO CART';
  }
  else {
    atcButton.setAttribute('disabled', true);
    atcButton.textContent = 'OUT OF STOCK';
  }

  //show costco/promo pricing
  costcoPrice.classList.remove('d-none');
  if (filteredProduct.compare_at_price_raw > filteredProduct.price_raw) {
    costcoPriceLabel.classList.add('d-none');
    costcoPricePromoLabel.classList.remove('d-none');
    regularPrice.classList.remove('d-none');
    reuglarPriceText.textContent = filteredProduct.compare_at_price;
    costcoPriceText.textContent = filteredProduct.price;
  }
  else {
    costcoPriceLabel.classList.remove('d-none');
    costcoPricePromoLabel.classList.add('d-none');
    regularPrice.classList.add('d-none');
    costcoPriceText.textContent = filteredProduct.price;
  }
  
  console.log('filteredProduct',filteredProduct);
}

function updateStartingPrice() {  
  let cheapestProduct = null;
  let cheapestPrice = Infinity;
  window.filteredChildProducts.forEach(product => {
    if (product.price_raw < cheapestPrice) {
      cheapestProduct = product;
      cheapestPrice = product.price_raw;
    }
  });
  if (cheapestProduct) {
    startingPriceLabel.textContent = cheapestProduct.price;
  }
}

function disableOptionStep(optionName, hasAvailableOption) {
  const optionStep = document.querySelector(`.product-option-column[data-option="${optionName}"]`);
  const optionNotApplicableEl = optionStep.querySelector('.not-applicable');
  optionStep.classList.toggle('disabled', !hasAvailableOption);
  const attributeValues = optionStep.querySelector('.attribute-values');
  attributeValues.classList.toggle('d-none', !hasAvailableOption);

  if (!hasAvailableOption && !optionNotApplicableEl) {
    attributeValues.insertAdjacentHTML('afterend', `<div class="not-applicable">Not Applicable</div>`);
  }
  else {
    if (optionNotApplicableEl && hasAvailableOption) {
      optionNotApplicableEl.remove();
    }
  }
}

function toggleOptionSelectedClasses(optionName, hide) {
  const optionStep = document.querySelector(`.product-option-column[data-option="${optionName}"]`);
  optionStep.classList.toggle('selected', !hide);
  const changeSelectionLink = document.querySelector(`.change-selection[data-option="${optionName}"]`);
  changeSelectionLink.classList.toggle('d-none', hide);


}
function refineFilteredProducts(attribute) {  
  console.log('refineFilteredProducts', attribute);
  const selectedOption = document.querySelector(`.attribute-values[data-option="${attribute}"] select`);
  const checkboxOptions = document.querySelectorAll(`.attribute-values[data-option="${attribute}"] input[type="checkbox"]`);
  const checkedOption = document.querySelector(`.attribute-values[data-option="${attribute}"] input[type="checkbox"].selected`);
  const buttonOptions = document.querySelectorAll(`.attribute-values[data-option="${attribute}"] button`);
  const buttonOptionSelected = document.querySelector(`.attribute-values[data-option="${attribute}"] button.selected`);
  let selectedValue = null;
  if (selectedOption) {
    selectedValue = (selectedOption.value) ? selectedOption.value : null;
  }
  else if (checkboxOptions.length > 0) {
    selectedValue = checkedOption?.getAttribute('data-value') || null;
  }
  else if (buttonOptions.length > 0) {
    selectedValue = buttonOptionSelected?.getAttribute('data-value') || null;
  }
  console.log('selectedValue', selectedValue);

  updateFilteredProducts(attribute, selectedValue);  
}

function updateFilteredProducts(attribute, selectedValue) {
  const productMetafield = mapProductAttributeToMetafield(attribute, selectedValue);
  if (!productMetafield) {
    console.warn("No product metafield found for attribute: " + attribute);
    return;
  }
  let filteredProducts = window.filteredChildProducts;
  for (let i = 0; i < filteredProducts.length; i++) {
    const product = filteredProducts[i];
    if (selectedValue) {
      const metafieldValueMatches = (Array.isArray(productMetafield)) ? productMetafieldMultiMatch(product, productMetafield, selectedValue) : productMetafieldMatch(product, productMetafield, selectedValue);
      console.log('metafieldValueMatches', metafieldValueMatches);
      //handle case where Heater only is selected and not Heater and Chromatherapy, which results in too many matches
      if (selectedValue === 'Heater' && metafieldValueMatches && (product['chromatherapy'] === 'Yes' || product['illumatherapy'] === 'Yes')) {
        filteredProducts.splice(i, 1);
        i--;
        continue;
      }
      if (selectedValue === 'No Heater') {
        if (product['heater_included'] === 'Yes') {
          filteredProducts.splice(i, 1);
          i--;
        }
        continue;
      }
      if (!metafieldValueMatches) {
        filteredProducts.splice(i, 1);
        i--;
      }      
    }
  }
  window.filteredChildProducts = filteredProducts;
  console.log('updateFilteredProducts result', attribute, selectedValue, window.filteredChildProducts);
}
function productMetafieldMultiMatch(product, productMetafield, selectedValue) {
  console.log('productMetafieldMultiMatch', productMetafield, selectedValue);
  let allMetafieldsMatch = true;
  for (let metafield of productMetafield) {
    console.log('productMetafieldMatch', metafield, selectedValue);
    const metafieldValueMatches = productMetafieldMatch(product, metafield, selectedValue);
    console.log('metafieldValueMatches',metafieldValueMatches)
    if (!metafieldValueMatches) {
      allMetafieldsMatch = false;
      break;
    }
  }
  return allMetafieldsMatch;
}

function productMetafieldMatch(product, productMetafield, selectedValue) {
  console.log('productMetafieldMatch', productMetafield, selectedValue);
  let metafieldMatchingValue = product[productMetafield];
  if (productMetafield === 'chromatherapy' || productMetafield === 'illumatherapy' || productMetafield === 'heater_included') {
    metafieldMatchingValue = (product[productMetafield] === 'Yes') 
      ? 
      metafieldMatchingValue = selectedValue
      : 
      null;
  }

  console.log('metafieldMatchingValue / product[productMetafield]', metafieldMatchingValue, product[productMetafield]);
    
  return metafieldMatchingValue === selectedValue;
}

function mapProductAttributeToMetafield(attribute, selectedValue) {
  switch (attribute) {
    case 'Color':
      return 'color';
    case 'Hydrotherapy Experience':
      return 'experience';
    case 'Equipment Location':
      return 'equipment_location';
    case 'Controls':
      return 'controls';
    case 'Whisper Technology':
      return 'whisper';
    case 'Whisper+ Technology':
      return 'whisper_plus';
    case 'Tub Filler':
      return 'bathtub_tubfiller_bundle';
    case 'Finish':
      return 'finish';
    case 'Drain Finish':
      return 'drain_finish';
    case 'Jet Trim Finish':
      return 'jet_trim_finish';
    case 'Size':
      return 'size';
    case 'Access Panels':
      return 'access_panels';
    case 'Packages':
      if (selectedValue === 'Chromatherapy') {
        return 'chromatherapy';
      }
      else if (selectedValue === 'Illumatherapy') {
        return 'illumatherapy';
      }
      else if (selectedValue === 'Heater' ||  selectedValue === 'No Heater') {
        return 'heater_included';
      }
      else if (selectedValue === 'Heater and Chromatherapy') {
        return ['heater_included', 'chromatherapy'];
      }
      else if (selectedValue === 'Heater and Illumatherapy') {
        return ['heater_included', 'illumatherapy'];
      }
      return 'chromatherapy';
    default:
      return '';
  }
}


(function() {
  function enableZoomEffect() {
    if (window.innerWidth < 992) {
      // Remove all zoom event handlers and reset zoom image styles for mobile/tablet
      $('.zoom-container').each(function() {
        var $container = $(this);
        var $zoomImg = $container.find('.zoomImg');
        $container.off('.zoomEffect');
        $zoomImg.css({
          opacity: 0,
          width: '',
          height: '',
          left: '',
          top: ''
        });
      });
      return;
    }

    $('.zoom-container').each(function() {
      var $container = $(this);
      var $mainImg = $container.find('.mainImg');
      var $zoomImg = $container.find('.zoomImg');
      var $slide = $container.closest('.slick-slide');

      // Remove any previous handlers to avoid stacking
      $container.off('.zoomEffect');

      $container.on('mouseenter.zoomEffect', function() {
  $zoomImg.css({ left: '', top: '' });
  $zoomImg.css('opacity', 1);
  var $spinner = $container.find('.zoom-loading-spinner');
  var mainImgSrc = $mainImg.attr('src');

  // Helper to get low-res and high-res zoom URLs
  // function getZoomUrl(url, size) {
  //   if (url.match(/[?&]width=\d+/) && url.match(/[?&]height=\d+/)) {
  //     url = url.replace(/([?&]width=)\d+/, `$1${size}`).replace(/([?&]height=)\d+/, `$1${size}`);
  //     return url;
  //   }
  //   if (/_\d{2,4}x\d{2,4}/.test(url)) {
  //     return url.replace(/(_\d{2,4}x\d{2,4})/, `_${size}x${size}`);
  //   }
  //   return url;
  // }

  // var highResUrl = getZoomUrl(mainImgSrc, 3000);

  // Always ensure the correct src is set
  if ($zoomImg.attr('src') !== mainImgSrc) {
    $zoomImg.attr('src', mainImgSrc);
  }

  // If the image is loaded, show it immediately and hide spinner
  if ($zoomImg[0].complete && $zoomImg[0].naturalWidth > 0) {
    $zoomImg.css('opacity', 1);
    $spinner.hide();
  } else {
    // Otherwise, show spinner and wait for image to load
    $spinner.show();
    $zoomImg.css('opacity', 0);
    $zoomImg.off('load.zoomShow');
    var showZoomImg = function() {
      $zoomImg.css('opacity', 1);
      $spinner.hide();
      $zoomImg.off('load.zoomShow');
    };
    $zoomImg.on('load.zoomShow', showZoomImg);
    // If image is already loaded (from cache), trigger handler immediately
    if ($zoomImg[0] && $zoomImg[0].complete) {
      showZoomImg();
    }
  }

  var containerWidth = $container.width();
  var containerHeight = $container.height();
  var naturalWidth = $zoomImg[0].naturalWidth;
  var naturalHeight = $zoomImg[0].naturalHeight;
  var minZoomRatio = 1.2;

  if (!$slide.hasClass('filter-image')) {
    // For non-filter images: constrain zoom
    if (naturalWidth < containerWidth * minZoomRatio || naturalHeight < containerHeight * minZoomRatio) {
      $zoomImg.css({
        width: containerWidth + 'px',
        height: containerHeight + 'px'
      });
    } else {
      var maxZoomWidth = Math.max(containerWidth * minZoomRatio, Math.min(naturalWidth, containerWidth * 2));
      var maxZoomHeight = Math.max(containerHeight * minZoomRatio, Math.min(naturalHeight, containerHeight * 2));
      $zoomImg.css({
        width: maxZoomWidth + 'px',
        height: maxZoomHeight + 'px'
      });
    }
  } else {
    // For filter images: always use natural size
    $zoomImg.css({
      width: naturalWidth + 'px',
      height: naturalHeight + 'px'
    });
  }
});

      $container.on('mousemove.zoomEffect', function(e) {
        var containerOffset = $container.offset();
        var relX = e.pageX - containerOffset.left;
        var relY = e.pageY - containerOffset.top;

        var containerWidth = $container.width();
        var containerHeight = $container.height();

        var zoomWidth = $zoomImg.width();
        var zoomHeight = $zoomImg.height();

        var maxX = zoomWidth - containerWidth;
        var maxY = zoomHeight - containerHeight;

        var percX = relX / containerWidth;
        var percY = relY / containerHeight;

        var left = -Math.max(0, Math.min(maxX, percX * maxX));
        var top = -Math.max(0, Math.min(maxY, percY * maxY));

        // For non-filter images with no zoom, keep centered
        if (!$slide.hasClass('filter-image')) {
          var naturalWidth = $zoomImg[0].naturalWidth;
          var naturalHeight = $zoomImg[0].naturalHeight;
          var minZoomRatio = 1.2;
          if (naturalWidth < containerWidth * minZoomRatio || naturalHeight < containerHeight * minZoomRatio) {
            left = 0;
            top = 0;
          }
        }

        $zoomImg.css({
          left: left + 'px',
          top: top + 'px'
        });
      });

      $container.on('mouseleave.zoomEffect', function() {
        var $spinner = $container.find('.zoom-loading-spinner');
        $zoomImg.css('opacity', 0);
        $spinner.hide();
        // Optionally reset zoomImg to low-res or blank
      });
    });
  }

  
  // Initialize on document ready and after each Slick change
  $(document).ready(function() {
    enableZoomEffect();
    toggleLoader(false);
    var $slider = $('.product-image-slider__body');
    if ($slider.length && typeof $.fn.slick !== 'undefined') {
      $slider.on('afterChange', function() {
        setTimeout(enableZoomEffect, 100);
      });
    }

    // Re-init on resize for responsiveness
    $(window).on('resize', function() {
      setTimeout(enableZoomEffect, 250);
    });
  });
})();

function setCookie(name, value, daysToLive) {
  // Encode value in order to escape semicolons, commas, and whitespace
  var cookie = name + "=" + encodeURIComponent(value);
  
  if(typeof daysToLive === "number") {
      /* Sets the max-age attribute so that the cookie expires
      after the specified number of days */
      cookie += "; path=/; secure; max-age=" + (daysToLive*24*60*60);
      
      document.cookie = cookie;
  }
}
function getCookie(name) {
  // Split cookie string and get all individual name=value pairs in an array
  var cookieArr = document.cookie.split(";");
  
  // Loop through the array elements
  for(var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");
      
      /* Removing whitespace at the beginning of the cookie name
      and compare it with the given string */
      if(name == cookiePair[0].trim()) {
          // Decode the cookie value and return
          return decodeURIComponent(cookiePair[1]);
      }
  }
  
  // Return null if not found
  return null;
}